const note = {
	icon: 'fa-fw fal fa-sticky-note',
	text: 'notificationTypes.note_text',
	title: 'notificationTypes.note_title',
	link: {
		to: {
			name: 'noteView',
		},
	},
}
export default {
	'App\\Notifications\\LostPassword': {
		icon: 'fa-fw fal fa-lock',
		text: 'notificationTypes.lostpassword_text',
		title: 'notificationTypes.lostpassword_title',
	},
	'App\\Notifications\\Welcome': {
		icon: 'fa-fw fal fa-unlock',
		text: 'notificationTypes.welcome_text',
		title: 'notificationTypes.welcome_title',
	},
	'App\\Notifications\\Message': {
		icon: 'fa-fw fal fa-envelope',
		text: 'notificationTypes.message_text',
		title: 'notificationTypes.message_title',
	},
	'App\\Notifications\\MessageDone': {
		icon: 'fa-fw fal fa-envelope',
		text: 'notificationTypes.messagedone_text',
		title: 'notificationTypes.messagedone_title',
		link: {
			to: {
				name: 'profile',
			},
			name: 'notificationTypes.messagedone_name',
		},
	},
	'App\\Notifications\\NotesAllUsers': note,
	'App\\Notifications\\Notes': note,
	'App\\Notifications\\DamageReport': {
		icon: 'fa-fw fal fa-house-damage',
		text: 'notificationTypes.damagereport_text',
		title: 'notificationTypes.damagereport_title',
	},
	'App\\Notifications\\MeterLevelDaily': {
		icon: 'fa-fw fas fa-tachometer-alt',
		text: 'notificationTypes.meterleveldaily_text',
		title: 'notificationTypes.meterleveldaily_title',
		link: {
			to: {
				name: 'adminMeters',
			},
			name: 'notificationTypes.meterleveldaily_name',
		},
	},
	'App\\Notifications\\DocumentUserNotification': {
		icon: 'fa-fw fas fa-file',
		text: 'notificationTypes.documentuser_text',
		title: 'notificationTypes.documentuser_title',
		link: {
			to: {
				name: 'notificationDocuments',
			},
			name: 'notificationTypes.documentuser_name',
		},
	},
	'App\\Notifications\\SyncStatusNotification': {
		icon: 'fa-fw fas fa-file',
		text: 'notificationTypes.syncstatus_text',
		title: 'notificationTypes.syncstatus_title',
		link: {
			to: {
				name: 'sync',
			},
			name: 'notificationTypes.syncstatus_name',
		},
	},
	'App\\Notifications\\QuotaExceededNotification': {
		icon: 'fa-fw fas fa-hdd',
		text: 'notificationTypes.quotaexceeded_text',
		title: 'notificationTypes.quotaexceeded_title',
		link: {
			to: { name: 'usageStorage' },
			name: 'notificationTypes.quotaexceeded_name',
		},
	},
	'App\\Notifications\\MeterLevelRejected': {
		icon: 'far fa-hand-paper',
		text: 'notificationTypes.meterlevelrejected_text',
		title: 'notificationTypes.meterlevelrejected_title',
	},
	'App\\Notifications\\HandOverInvitation': {
		icon: 'fa-fw fal fa-clipboard-list',
		text: 'notificationTypes.handoverinvitation_text',
		title: 'notificationTypes.handoverinvitation_title',
		link: {
			name: 'notificationTypes.handoverinvitation_name',
		},
	},
	'App\\Notifications\\PersonUpdateRequest': {
		icon: 'fas fa-user-edit',
		title: 'notificationTypes.personupdate_text',
		text: 'notificationTypes.personupdate_title',
		link: {
			to: {
				name: 'profile',
			},
			name: 'notificationTypes.personupdate_name',
		},
	},
	'App\\Notifications\\PersonUpdateRequestAdmin': {
		icon: 'fas fa-user-edit',
		title: 'notificationTypes.personupdateadmin_text',
		text: 'notificationTypes.personupdateadmin_title',
		ink: {
			to: {
				name: 'updateRequests',
			},
			name: 'notificationTypes.personupdateadmin_name',
		},
	},
	'App\\Notifications\\ConsumptionNotification': {
		icon: 'fa-fw fas fa-heat',
		text: 'notificationTypes.consumptionnotification_text',
		title: 'notificationTypes.consumptionnotification_title',
		link: {
			to: {
				name: 'unit',
			},
			name: 'notificationTypes.consumptionnotification_name',
		},
	},
	'App\\Notifications\\PrivacyTosRejected': {
		icon: 'fa-fw fas fa-vote-nay',
		title: 'notificationTypes.privacytosrejected_text',
		text: 'notificationTypes.privacytosrejected_title',
		link: {
			to: {
				name: 'notificationView',
			},
			name: 'notificationTypes.privacytosrejected_name',
		},
	},
	'App\\Notifications\\TicketHistoryNotification': {
		icon: 'fa-solid fa-ticket',
		title: 'notificationTypes.tickethistory_text',
		text: 'notificationTypes.tickethistory_title',
		link: {
			to: {
				name: 'ticket',
			},
			name: 'notificationTypes.tickethistory_name',
		},
	},
	'App\\Notifications\\ReviewDocumentNotification': {
		icon: 'fa-fw fa-regular fa-magnifying-glass-dollar',
		title: 'notificationTypes.reviewdocument_title',
		link: {
			to: {
				name: 'reviewDocument',
			},
			name: 'notificationTypes.reviewdocument_name',
		},
	},
	'App\\Notifications\\ReportNotification': {
		icon: 'fa-solid fa-ticket',
		title: 'notificationTypes.reportnotification_title',
		text: 'notificationTypes.reportnotification_text',
	},
}
